import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import ReportSection from '@/_core/entities/report/ui/ReportSection/ReportSection.vue';
import ExpandToggleButton from '@/_core/shared/ui/ExpandToggleButton/ExpandToggleButton.vue';
import ExpandableVulnerabilitySection from '../ExpandableVulnerabilitySection/ExpandableVulnerabilitySection.vue';
import VulnerabilityCodeBlock from '../VulnerabilityCodeBlock/VulnerabilityCodeBlock.vue';
import VulnerabilityPOC from '../VulnerabilityPOC/VulnerabilityPOC.vue';
import TrialOverlay from '../TrialOverlay/TrialOverlay.vue';
import { trackVulnSectionExpanded } from '@/services/analytics';
import StackTraceViewer from '@/components/scans/StackTraceViewer.vue';
import VulnAttachmentList from '@/components/scans/VulnAttachmentList.vue';
import { TReport } from '@/_core/entities/report/models/types';
import dayjs from 'dayjs';
import type {
  TVulnerabilityCodeLine,
  TVulnerabilityDetails,
} from '@/_core/entities/vulnerability/models/types';
import {
  trialMockCodeBlock,
  trialMockProofOfConcepts,
  trialMockStackTraces,
  trialMockAttachments,
} from '@/_core/entities/vulnerability/models/mock.data';


export default /*#__PURE__*/_defineComponent({
  __name: 'VulnerabilityEvidenceDetails',
  props: {
    vulnerability: null,
    reportData: null
  },
  setup(__props: any) {

const props = __props as {
  vulnerability: TVulnerabilityDetails;
  reportData: TReport | undefined;
};



function getCodeBlockLeadingSpacesNumber(lines: TVulnerabilityCodeLine[]): number {
  if (lines.length === 0) return 0;
  return lines.reduce((min, line) => {
    const leading = line.content.match(/^(\s*)/)?.[1].length ?? 0;
    return Math.min(min, leading);
  }, 100);
}

const codeBlocks = computed(
  () =>
    props.vulnerability.blocks?.map((block) => ({
      ...block,
      minSpaces: getCodeBlockLeadingSpacesNumber(block.lines),
    })) || []
);

const expandedSections = ref({
  code: true,
  poc: true,
  stacktraces: true,
  attachments: true,
});

const allExpanded = computed(() => {
  return Object.values(expandedSections.value).every((s) => !!s);
});

function toggleAll() {
  expandedSections.value = {
    code: !allExpanded.value,
    poc: !allExpanded.value,
    stacktraces: !allExpanded.value,
    attachments: !allExpanded.value,
  };
}

const sectionAnalyticsNames: Record<string, string> = {
  code: 'code',
  poc: 'poc',
  stacktraces: 'stack_traces',
  attachments: 'attachments',
};

function handleSectionToggle(section: string, expanded: boolean) {
  (expandedSections.value as Record<string, boolean>)[section] = expanded;
  if (expanded) {
    trackVulnSectionExpanded(
      props.vulnerability.jobId,
      props.vulnerability.category.descriptionTitle,
      sectionAnalyticsNames[section] || section,
    );
  }
}

const showAllFiles = ref(false);

const isAttachmentsExpired = computed(() => {
  const days = props.reportData?.reportRetentionDays;
  const createdAt = props.reportData?.createdAt;
  if (!days || !createdAt) return false;
  return dayjs().isAfter(dayjs(createdAt).add(days, 'day'));
});

return { __sfc: true,props, getCodeBlockLeadingSpacesNumber, codeBlocks, expandedSections, allExpanded, toggleAll, sectionAnalyticsNames, handleSectionToggle, showAllFiles, isAttachmentsExpired, ReportSection, ExpandToggleButton, ExpandableVulnerabilitySection, VulnerabilityCodeBlock, VulnerabilityPOC, TrialOverlay, StackTraceViewer, VulnAttachmentList, trialMockCodeBlock, trialMockProofOfConcepts, trialMockStackTraces, trialMockAttachments }
}

})